import { Component, OnInit, OnDestroy } from '@angular/core';
import { SurveyForm } from 'src/app/shared/models/survey/surveyForm';
import { Subscription } from 'rxjs';
import { SurveyService } from 'src/app/shared/services/survey.service';

@Component({
  selector: 'survey-expired',
  templateUrl: './survey-expired.component.html',
  styleUrls: ['./survey-expired.component.scss'],
  standalone: false
})
export class SurveyExpiredComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  survey: SurveyForm;

  constructor(private surveyService: SurveyService) {}

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription = this.surveyService.survey.subscribe((result) => {
      if (result) {
        this.survey = result;
        this.surveyService.setSurveyForm();
      }
    });
  }
}
